import React from "react";
import {Auth0Provider} from '@auth0/auth0-react';
import {resolveTenant} from './tenant';
import {fetchTenantConfig} from './tenant-config';
import {TenantConfigProvider} from "./tenant-config-context";

type Props = { children: React.ReactNode };

export default function TenantBoot({children}: Props) {
    const [cfg, setCfg] = React.useState(null);
    const [err, setErr] = React.useState(null);
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        const run = async () => {
            try {
                const tenant = resolveTenant();
                const tenantPublicConfig = await fetchTenantConfig(tenant);
                setCfg(tenantPublicConfig);
            } catch (e) {
                setErr(e?.message ?? 'Failed loading tenant config');
            } finally {
                setLoading(false);
            }
        };
        void run();
    }, []);

    if (loading) return <div style={{padding: 24}}>Booting tenant…</div>;
    if (err || !cfg) return <div style={{color: 'crimson', padding: 24}}>Error: {err}</div>;

    const onRedirectCallback = (appState?: any) => {
        window.history.replaceState({}, document.title, appState?.returnTo || window.location.pathname);
    };

    // Keep your beheer redirect rule
    const redirectUri = window.location.pathname.startsWith('/beheer')
        ? `${window.location.origin}/beheer`
        : window.location.origin;

    const providerConfig = {
        domain: cfg.auth.domain,
        clientId: cfg.auth.clientId,
        onRedirectCallback,
        authorizationParams: {
            redirect_uri: redirectUri,
            ...(cfg.auth.audience ? {audience: cfg.auth.audience} : {}),
        },
        useRefreshTokens: true,
        cacheLocation: 'localstorage',
    };

    // Expose cfg via context if you like (optional). For now, just render Auth0Provider.
    return <Auth0Provider {...providerConfig}>
        <TenantConfigProvider cfg={cfg}>
            {children}
        </TenantConfigProvider>
    </Auth0Provider>;
}
